/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ApiException } from '../api-exception';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccountRequestDetail(accountRequestId: number): Observable<AccountRequestDetailModel> {
        let url_ = this.baseUrl + "/account-requests/{accountRequestId}";
        if (accountRequestId === undefined || accountRequestId === null)
            throw new Error("The parameter 'accountRequestId' must be defined.");
        url_ = url_.replace("{accountRequestId}", encodeURIComponent("" + accountRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<AccountRequestDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountRequestDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountRequestDetail(response: HttpResponseBase): Observable<AccountRequestDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountRequestDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    /**
     * The delivery method and frequency lookups the Contribution / Distribution funding step
    binds its selects to (req.DeliveryMethod / req.DeliveryFrequency).
     * @return The selectable delivery methods and the frequencies the portal offers.
     */
    getDeliveryOptions(): Observable<DeliveryOptionsModel> {
        let url_ = this.baseUrl + "/account-requests/delivery-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryOptions(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryOptionsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryOptionsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeliveryOptions(response: HttpResponseBase): Observable<DeliveryOptionsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DeliveryOptionsModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    downloadAccountRequestFile(accountRequestId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/account-requests/{accountRequestId}/files/{fileId}";
        if (accountRequestId === undefined || accountRequestId === null)
            throw new Error("The parameter 'accountRequestId' must be defined.");
        url_ = url_.replace("{accountRequestId}", encodeURIComponent("" + accountRequestId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAccountRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAccountRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadAccountRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountRequestsV2Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createAccountRequestV2(files: FileParameter[] | null | undefined, accountRequestModelBase: AccountRequestV2ModelBase | undefined): Observable<number> {
        let url_ = this.baseUrl + "/account-requests-v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (accountRequestModelBase === null || accountRequestModelBase === undefined)
            throw new Error("The parameter 'accountRequestModelBase' cannot be null.");
        else
            content_.append("AccountRequestModelBase", JSON.stringify(accountRequestModelBase));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAccountRequestV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccountRequestV2(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAccountRequestV2(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountUploadsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccountUploadsByAgentIds(agentIds: number[] | undefined): Observable<TaskFilesListModel[]> {
        let url_ = this.baseUrl + "/account-uploads?";
        if (agentIds === null)
            throw new Error("The parameter 'agentIds' cannot be null.");
        else if (agentIds !== undefined)
            agentIds && agentIds.forEach(item => { url_ += "agentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountUploadsByAgentIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountUploadsByAgentIds(<any>response_);
                } catch (e) {
                    return <Observable<TaskFilesListModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaskFilesListModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountUploadsByAgentIds(response: HttpResponseBase): Observable<TaskFilesListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TaskFilesListModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    postAccountMessage(accountMessageModel: AccountMessageModel | undefined, files: FileParameter[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/account-uploads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountMessageModel === null || accountMessageModel === undefined)
            throw new Error("The parameter 'accountMessageModel' cannot be null.");
        else
            content_.append("AccountMessageModel", JSON.stringify(accountMessageModel));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAccountMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAccountMessage(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processPostAccountMessage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    postPlanningDeskAccountMessage(accountMessageModel: PlanningDeskMessageModel | undefined, files: FileParameter[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/account-uploads/planning-desk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountMessageModel === null || accountMessageModel === undefined)
            throw new Error("The parameter 'accountMessageModel' cannot be null.");
        else
            content_.append("AccountMessageModel", JSON.stringify(accountMessageModel));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPlanningDeskAccountMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPlanningDeskAccountMessage(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processPostPlanningDeskAccountMessage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AgentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAgents(): Observable<AgentModel[]> {
        let url_ = this.baseUrl + "/agents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgents(<any>response_);
                } catch (e) {
                    return <Observable<AgentModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgents(response: HttpResponseBase): Observable<AgentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AgentModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getAgentSelf(): Observable<AgentModel> {
        let url_ = this.baseUrl + "/agents/self";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentSelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentSelf(<any>response_);
                } catch (e) {
                    return <Observable<AgentModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentSelf(response: HttpResponseBase): Observable<AgentModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AgentModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getParentAgents(includeSelf: boolean | undefined): Observable<AgentModel[]> {
        let url_ = this.baseUrl + "/agents/self/parent-agents?";
        if (includeSelf === null)
            throw new Error("The parameter 'includeSelf' cannot be null.");
        else if (includeSelf !== undefined)
            url_ += "includeSelf=" + encodeURIComponent("" + includeSelf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParentAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParentAgents(<any>response_);
                } catch (e) {
                    return <Observable<AgentModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetParentAgents(response: HttpResponseBase): Observable<AgentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AgentModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClientsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAgentClients(crmAgentId: number): Observable<ClientModel[]> {
        let url_ = this.baseUrl + "/agents/{crmAgentId}/clients";
        if (crmAgentId === undefined || crmAgentId === null)
            throw new Error("The parameter 'crmAgentId' must be defined.");
        url_ = url_.replace("{crmAgentId}", encodeURIComponent("" + crmAgentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentClients(<any>response_);
                } catch (e) {
                    return <Observable<ClientModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentClients(response: HttpResponseBase): Observable<ClientModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ClientModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CloseAccountRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createCloseAccountRequest(files: FileParameter[] | null | undefined, accountRequestModelBase: AccountRequestCloseModelBase | undefined): Observable<number> {
        let url_ = this.baseUrl + "/close-account-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (accountRequestModelBase === null || accountRequestModelBase === undefined)
            throw new Error("The parameter 'accountRequestModelBase' cannot be null.");
        else
            content_.append("AccountRequestModelBase", JSON.stringify(accountRequestModelBase));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCloseAccountRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCloseAccountRequest(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCloseAccountRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getCloseAccountRequestDetail(investmentAccountCloseRequestId: number): Observable<CloseAccountRequestDetailModel> {
        let url_ = this.baseUrl + "/close-account-requests/{investmentAccountCloseRequestId}";
        if (investmentAccountCloseRequestId === undefined || investmentAccountCloseRequestId === null)
            throw new Error("The parameter 'investmentAccountCloseRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountCloseRequestId}", encodeURIComponent("" + investmentAccountCloseRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloseAccountRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloseAccountRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<CloseAccountRequestDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CloseAccountRequestDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCloseAccountRequestDetail(response: HttpResponseBase): Observable<CloseAccountRequestDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CloseAccountRequestDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    downloadCloseAccountRequestFile(investmentAccountCloseRequestId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/close-account-requests/{investmentAccountCloseRequestId}/files/{fileId}";
        if (investmentAccountCloseRequestId === undefined || investmentAccountCloseRequestId === null)
            throw new Error("The parameter 'investmentAccountCloseRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountCloseRequestId}", encodeURIComponent("" + investmentAccountCloseRequestId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCloseAccountRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCloseAccountRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadCloseAccountRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContributionRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createContributionRequest(files: FileParameter[] | null | undefined, accountRequestModelBase: AccountRequestContributionModelBase | undefined): Observable<number> {
        let url_ = this.baseUrl + "/contribution-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (accountRequestModelBase === null || accountRequestModelBase === undefined)
            throw new Error("The parameter 'accountRequestModelBase' cannot be null.");
        else
            content_.append("AccountRequestModelBase", JSON.stringify(accountRequestModelBase));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContributionRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContributionRequest(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateContributionRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getContributionRequestDetail(investmentAccountContributionRequestId: number): Observable<ContributionRequestDetailModel> {
        let url_ = this.baseUrl + "/contribution-requests/{investmentAccountContributionRequestId}";
        if (investmentAccountContributionRequestId === undefined || investmentAccountContributionRequestId === null)
            throw new Error("The parameter 'investmentAccountContributionRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountContributionRequestId}", encodeURIComponent("" + investmentAccountContributionRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContributionRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContributionRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<ContributionRequestDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContributionRequestDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetContributionRequestDetail(response: HttpResponseBase): Observable<ContributionRequestDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ContributionRequestDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    downloadContributionRequestFile(investmentAccountContributionRequestId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/contribution-requests/{investmentAccountContributionRequestId}/files/{fileId}";
        if (investmentAccountContributionRequestId === undefined || investmentAccountContributionRequestId === null)
            throw new Error("The parameter 'investmentAccountContributionRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountContributionRequestId}", encodeURIComponent("" + investmentAccountContributionRequestId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadContributionRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadContributionRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadContributionRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CrmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCrmHealthCheck(): Observable<boolean> {
        let url_ = this.baseUrl + "/acmcrm/healthcheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrmHealthCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrmHealthCheck(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetCrmHealthCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustodiansClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCustodians(): Observable<CustodianModel[]> {
        let url_ = this.baseUrl + "/custodians";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustodians(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustodians(<any>response_);
                } catch (e) {
                    return <Observable<CustodianModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustodianModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustodians(response: HttpResponseBase): Observable<CustodianModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustodianModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DistributionRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createDistributionRequest(files: FileParameter[] | null | undefined, accountRequestModelBase: AccountRequestDistributionModelBase | undefined): Observable<number> {
        let url_ = this.baseUrl + "/distribution-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (accountRequestModelBase === null || accountRequestModelBase === undefined)
            throw new Error("The parameter 'accountRequestModelBase' cannot be null.");
        else
            content_.append("AccountRequestModelBase", JSON.stringify(accountRequestModelBase));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDistributionRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDistributionRequest(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDistributionRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getDistributionRequestDetail(investmentAccountDistributionRequestId: number): Observable<DistributionRequestDetailModel> {
        let url_ = this.baseUrl + "/distribution-requests/{investmentAccountDistributionRequestId}";
        if (investmentAccountDistributionRequestId === undefined || investmentAccountDistributionRequestId === null)
            throw new Error("The parameter 'investmentAccountDistributionRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountDistributionRequestId}", encodeURIComponent("" + investmentAccountDistributionRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistributionRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistributionRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<DistributionRequestDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<DistributionRequestDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetDistributionRequestDetail(response: HttpResponseBase): Observable<DistributionRequestDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DistributionRequestDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    downloadDistributionRequestFile(investmentAccountDistributionRequestId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/distribution-requests/{investmentAccountDistributionRequestId}/files/{fileId}";
        if (investmentAccountDistributionRequestId === undefined || investmentAccountDistributionRequestId === null)
            throw new Error("The parameter 'investmentAccountDistributionRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountDistributionRequestId}", encodeURIComponent("" + investmentAccountDistributionRequestId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDistributionRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDistributionRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadDistributionRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FirstMfaSetupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    setupMfaDevice(model: FirstMfaSetupPostModel): Observable<void> {
        let url_ = this.baseUrl + "/first-mfa-setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetupMfaDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetupMfaDevice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetupMfaDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    verifyMfaDevice(model: FirstMfaVerificationPostModel): Observable<void> {
        let url_ = this.baseUrl + "/first-mfa-setup/verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyMfaDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyMfaDevice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyMfaDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InsuranceAccountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInsuranceAccountsByCrds(crds: string[] | undefined): Observable<PolicyByCrdListModel[]> {
        let url_ = this.baseUrl + "/insurance-accounts?";
        if (crds === null)
            throw new Error("The parameter 'crds' cannot be null.");
        else if (crds !== undefined)
            crds && crds.forEach(item => { url_ += "crds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuranceAccountsByCrds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuranceAccountsByCrds(<any>response_);
                } catch (e) {
                    return <Observable<PolicyByCrdListModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyByCrdListModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInsuranceAccountsByCrds(response: HttpResponseBase): Observable<PolicyByCrdListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PolicyByCrdListModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvestmentAccountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInvestmentAccountsByAgentIds(agentIds: number[] | undefined): Observable<AccountModel[]> {
        let url_ = this.baseUrl + "/investment-accounts/v1?";
        if (agentIds === null)
            throw new Error("The parameter 'agentIds' cannot be null.");
        else if (agentIds !== undefined)
            agentIds && agentIds.forEach(item => { url_ += "agentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestmentAccountsByAgentIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestmentAccountsByAgentIds(<any>response_);
                } catch (e) {
                    return <Observable<AccountModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvestmentAccountsByAgentIds(response: HttpResponseBase): Observable<AccountModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getInvestmentAccountsByAgentIdsV2(agentIds: number[] | undefined): Observable<AccountListModel[]> {
        let url_ = this.baseUrl + "/investment-accounts/v2?";
        if (agentIds === null)
            throw new Error("The parameter 'agentIds' cannot be null.");
        else if (agentIds !== undefined)
            agentIds && agentIds.forEach(item => { url_ += "agentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestmentAccountsByAgentIdsV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestmentAccountsByAgentIdsV2(<any>response_);
                } catch (e) {
                    return <Observable<AccountListModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountListModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvestmentAccountsByAgentIdsV2(response: HttpResponseBase): Observable<AccountListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountListModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getInvestmentAccountTypes(): Observable<InvestmentAccountTypeModel[]> {
        let url_ = this.baseUrl + "/investment-accounts/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestmentAccountTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestmentAccountTypes(<any>response_);
                } catch (e) {
                    return <Observable<InvestmentAccountTypeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvestmentAccountTypeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvestmentAccountTypes(response: HttpResponseBase): Observable<InvestmentAccountTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InvestmentAccountTypeModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    createInvestmentAccount(files: FileParameter[] | undefined, client: PaperUploadClientModel | null | undefined, account: PaperUploadAccountModel | undefined, agentID: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/investment-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (client !== null && client !== undefined)
            content_.append("Client", JSON.stringify(client));
        if (account === null || account === undefined)
            throw new Error("The parameter 'account' cannot be null.");
        else
            content_.append("Account", JSON.stringify(account));
        if (agentID === null || agentID === undefined)
            throw new Error("The parameter 'agentID' cannot be null.");
        else
            content_.append("AgentID", agentID.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvestmentAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvestmentAccount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInvestmentAccount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    searchAcmAccountsForAgentIds(agentIds: number[] | undefined, searchTerm: string | undefined): Observable<AccountSearchListModel[]> {
        let url_ = this.baseUrl + "/investment-accounts/search?";
        if (agentIds === null)
            throw new Error("The parameter 'agentIds' cannot be null.");
        else if (agentIds !== undefined)
            agentIds && agentIds.forEach(item => { url_ += "agentIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAcmAccountsForAgentIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAcmAccountsForAgentIds(<any>response_);
                } catch (e) {
                    return <Observable<AccountSearchListModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountSearchListModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearchAcmAccountsForAgentIds(response: HttpResponseBase): Observable<AccountSearchListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSearchListModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getInvestmentAccount(investmentAccountId: number): Observable<AccountModel> {
        let url_ = this.baseUrl + "/investment-accounts/{investmentAccountId}";
        if (investmentAccountId === undefined || investmentAccountId === null)
            throw new Error("The parameter 'investmentAccountId' must be defined.");
        url_ = url_.replace("{investmentAccountId}", encodeURIComponent("" + investmentAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestmentAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestmentAccount(<any>response_);
                } catch (e) {
                    return <Observable<AccountModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvestmentAccount(response: HttpResponseBase): Observable<AccountModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvestmentModelsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInvestmentModels(): Observable<InvestmentModel[]> {
        let url_ = this.baseUrl + "/investment-models";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestmentModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestmentModels(<any>response_);
                } catch (e) {
                    return <Observable<InvestmentModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvestmentModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvestmentModels(response: HttpResponseBase): Observable<InvestmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InvestmentModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getAgentInvestmentModels(agentIds: number[] | undefined): Observable<InvestmentModel[]> {
        let url_ = this.baseUrl + "/agents/investment-models?";
        if (agentIds === null)
            throw new Error("The parameter 'agentIds' cannot be null.");
        else if (agentIds !== undefined)
            agentIds && agentIds.forEach(item => { url_ += "agentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentInvestmentModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentInvestmentModels(<any>response_);
                } catch (e) {
                    return <Observable<InvestmentModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvestmentModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentInvestmentModels(response: HttpResponseBase): Observable<InvestmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InvestmentModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LoginClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(model: LoginPostModel): Observable<LoginResponseModel> {
        let url_ = this.baseUrl + "/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LoginResponseModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <LoginFailureResponseModel>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    verifyMfa(model: MfaVerificationPostModel): Observable<void> {
        let url_ = this.baseUrl + "/login/mfa-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyMfa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyMfa(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyMfa(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OptOutClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    logNewPortalOptOut(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/opt-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogNewPortalOptOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogNewPortalOptOut(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLogNewPortalOptOut(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrionServiceRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getOrionServiceRequestDetail(orionServiceRequestId: number): Observable<OrionServiceRequestModel2> {
        let url_ = this.baseUrl + "/orion-service-request-requests/{orionServiceRequestId}";
        if (orionServiceRequestId === undefined || orionServiceRequestId === null)
            throw new Error("The parameter 'orionServiceRequestId' must be defined.");
        url_ = url_.replace("{orionServiceRequestId}", encodeURIComponent("" + orionServiceRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrionServiceRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrionServiceRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<OrionServiceRequestModel2>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionServiceRequestModel2>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrionServiceRequestDetail(response: HttpResponseBase): Observable<OrionServiceRequestModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionServiceRequestModel2>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getOrionServiceRequestFile(orionServiceRequestId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/orion-service-request-requests/{orionServiceRequestId}/files/{fileId}";
        if (orionServiceRequestId === undefined || orionServiceRequestId === null)
            throw new Error("The parameter 'orionServiceRequestId' must be defined.");
        url_ = url_.replace("{orionServiceRequestId}", encodeURIComponent("" + orionServiceRequestId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrionServiceRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrionServiceRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrionServiceRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PasswordResetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    requestPasswordReset(model: PasswordResetRequestModel): Observable<void> {
        let url_ = this.baseUrl + "/password-reset/request-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPasswordReset(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRequestPasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    validatePasswordReset(resetCode: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/password-reset/validate?";
        if (resetCode === null)
            throw new Error("The parameter 'resetCode' cannot be null.");
        else if (resetCode !== undefined)
            url_ += "resetCode=" + encodeURIComponent("" + resetCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePasswordReset(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePasswordReset(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    createNewPassword(model: CreateNewPasswordModel): Observable<void> {
        let url_ = this.baseUrl + "/password-reset/create-new-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewPassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateNewPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <CreateNewPasswordResultFailureType>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    verifyMfa(model: MfaVerifyModel): Observable<void> {
        let url_ = this.baseUrl + "/password-reset/verify-mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyMfa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyMfa(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyMfa(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <CreateNewPasswordResultFailureType>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PermissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserPermissions(): Observable<UserPermissionModel[]> {
        let url_ = this.baseUrl + "/permissions/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<UserPermissionModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPermissionModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPermissions(response: HttpResponseBase): Observable<UserPermissionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserPermissionModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlanningDeskRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createPlanningDeskRequest(files: FileParameter[] | null | undefined, planningDeskModelBase: PlanningDeskModelBase | undefined): Observable<number> {
        let url_ = this.baseUrl + "/planning-desk-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (planningDeskModelBase === null || planningDeskModelBase === undefined)
            throw new Error("The parameter 'planningDeskModelBase' cannot be null.");
        else
            content_.append("PlanningDeskModelBase", JSON.stringify(planningDeskModelBase));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlanningDeskRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlanningDeskRequest(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePlanningDeskRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getPlanningDeskRequestDetail(portfolioAnalysisRequestId: number): Observable<PlanningDeskRequestDetailModel> {
        let url_ = this.baseUrl + "/planning-desk-requests/{portfolioAnalysisRequestId}";
        if (portfolioAnalysisRequestId === undefined || portfolioAnalysisRequestId === null)
            throw new Error("The parameter 'portfolioAnalysisRequestId' must be defined.");
        url_ = url_.replace("{portfolioAnalysisRequestId}", encodeURIComponent("" + portfolioAnalysisRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanningDeskRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanningDeskRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<PlanningDeskRequestDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanningDeskRequestDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanningDeskRequestDetail(response: HttpResponseBase): Observable<PlanningDeskRequestDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PlanningDeskRequestDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    downloadPlanningDeskRequestFile(portfolioAnalysisRequestId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/planning-desk-requests/{portfolioAnalysisRequestId}/files/{fileId}";
        if (portfolioAnalysisRequestId === undefined || portfolioAnalysisRequestId === null)
            throw new Error("The parameter 'portfolioAnalysisRequestId' must be defined.");
        url_ = url_.replace("{portfolioAnalysisRequestId}", encodeURIComponent("" + portfolioAnalysisRequestId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPlanningDeskRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPlanningDeskRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadPlanningDeskRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReallocationRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createReallocationRequest(files: FileParameter[] | null | undefined, accountRequestModelBase: AccountRequestReallocationModelBase | undefined): Observable<number> {
        let url_ = this.baseUrl + "/reallocation-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (accountRequestModelBase === null || accountRequestModelBase === undefined)
            throw new Error("The parameter 'accountRequestModelBase' cannot be null.");
        else
            content_.append("AccountRequestModelBase", JSON.stringify(accountRequestModelBase));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReallocationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReallocationRequest(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateReallocationRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getReallocationRequestDetail(investmentAccountReallocationRequestId: number): Observable<ReallocationRequestDetailModel> {
        let url_ = this.baseUrl + "/reallocation-requests/{investmentAccountReallocationRequestId}";
        if (investmentAccountReallocationRequestId === undefined || investmentAccountReallocationRequestId === null)
            throw new Error("The parameter 'investmentAccountReallocationRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountReallocationRequestId}", encodeURIComponent("" + investmentAccountReallocationRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReallocationRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReallocationRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<ReallocationRequestDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReallocationRequestDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetReallocationRequestDetail(response: HttpResponseBase): Observable<ReallocationRequestDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ReallocationRequestDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    downloadReallocationRequestFile(investmentAccountReallocationRequestId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/reallocation-requests/{investmentAccountReallocationRequestId}/files/{fileId}";
        if (investmentAccountReallocationRequestId === undefined || investmentAccountReallocationRequestId === null)
            throw new Error("The parameter 'investmentAccountReallocationRequestId' must be defined.");
        url_ = url_.replace("{investmentAccountReallocationRequestId}", encodeURIComponent("" + investmentAccountReallocationRequestId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReallocationRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReallocationRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadReallocationRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RegistrationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSelfRegistration(): Observable<RegistrationDetailResponseModel> {
        let url_ = this.baseUrl + "/registrations/self";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelfRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelfRegistration(<any>response_);
                } catch (e) {
                    return <Observable<RegistrationDetailResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegistrationDetailResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetSelfRegistration(response: HttpResponseBase): Observable<RegistrationDetailResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegistrationDetailResponseModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    completeRegistration(model: CompleteRegistrationModel): Observable<void> {
        let url_ = this.baseUrl + "/registrations/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteRegistration(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <CompleteRegistrationFailureType>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRequestsByAgentIds(agentIds: number[] | undefined): Observable<RequestModel[]> {
        let url_ = this.baseUrl + "/requests?";
        if (agentIds === null)
            throw new Error("The parameter 'agentIds' cannot be null.");
        else if (agentIds !== undefined)
            agentIds && agentIds.forEach(item => { url_ += "agentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestsByAgentIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestsByAgentIds(<any>response_);
                } catch (e) {
                    return <Observable<RequestModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestsByAgentIds(response: HttpResponseBase): Observable<RequestModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RequestModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getRequestsByAgentIdsV2(agentIds: number[] | undefined): Observable<RequestModel[]> {
        let url_ = this.baseUrl + "/requests/V2?";
        if (agentIds === null)
            throw new Error("The parameter 'agentIds' cannot be null.");
        else if (agentIds !== undefined)
            agentIds && agentIds.forEach(item => { url_ += "agentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestsByAgentIdsV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestsByAgentIdsV2(<any>response_);
                } catch (e) {
                    return <Observable<RequestModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestsByAgentIdsV2(response: HttpResponseBase): Observable<RequestModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RequestModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getGeneralAccountRequestDetail(investmentAccountUploadId: number): Observable<GeneralAccountRequestDetailModel> {
        let url_ = this.baseUrl + "/requests/general-account/{investmentAccountUploadId}";
        if (investmentAccountUploadId === undefined || investmentAccountUploadId === null)
            throw new Error("The parameter 'investmentAccountUploadId' must be defined.");
        url_ = url_.replace("{investmentAccountUploadId}", encodeURIComponent("" + investmentAccountUploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralAccountRequestDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralAccountRequestDetail(<any>response_);
                } catch (e) {
                    return <Observable<GeneralAccountRequestDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneralAccountRequestDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralAccountRequestDetail(response: HttpResponseBase): Observable<GeneralAccountRequestDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GeneralAccountRequestDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    downloadContributionRequestFile(investmentAccountUploadId: number, fileId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/requests/general-account/{investmentAccountUploadId}/files/{fileId}";
        if (investmentAccountUploadId === undefined || investmentAccountUploadId === null)
            throw new Error("The parameter 'investmentAccountUploadId' must be defined.");
        url_ = url_.replace("{investmentAccountUploadId}", encodeURIComponent("" + investmentAccountUploadId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadContributionRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadContributionRequestFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadContributionRequestFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    createRequestSurvey(requestID: number | undefined, investmentAccountID: number | undefined, rating: number | undefined, requestDescription: string | undefined, goodNotes: string | undefined, badNotes: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/requests/survey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requestID === null || requestID === undefined)
            throw new Error("The parameter 'requestID' cannot be null.");
        else
            content_.append("RequestID", requestID.toString());
        if (investmentAccountID === null || investmentAccountID === undefined)
            throw new Error("The parameter 'investmentAccountID' cannot be null.");
        else
            content_.append("InvestmentAccountID", investmentAccountID.toString());
        if (rating === null || rating === undefined)
            throw new Error("The parameter 'rating' cannot be null.");
        else
            content_.append("Rating", rating.toString());
        if (requestDescription === null || requestDescription === undefined)
            throw new Error("The parameter 'requestDescription' cannot be null.");
        else
            content_.append("RequestDescription", requestDescription.toString());
        if (goodNotes === null || goodNotes === undefined)
            throw new Error("The parameter 'goodNotes' cannot be null.");
        else
            content_.append("GoodNotes", goodNotes.toString());
        if (badNotes === null || badNotes === undefined)
            throw new Error("The parameter 'badNotes' cannot be null.");
        else
            content_.append("BadNotes", badNotes.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRequestSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRequestSurvey(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRequestSurvey(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SchwabClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccountDetails(accountId: number | undefined): Observable<SchwabAccountDetailModel> {
        let url_ = this.baseUrl + "/schwab/account/account-detail?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountDetails(<any>response_);
                } catch (e) {
                    return <Observable<SchwabAccountDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SchwabAccountDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountDetails(response: HttpResponseBase): Observable<SchwabAccountDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SchwabAccountDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getAccountStandingInstructions(accountId: number | undefined, schwabMasterAccount: number | undefined, schwabFormattedAccount: number | undefined): Observable<StandingInstruction[]> {
        let url_ = this.baseUrl + "/schwab/account/standing-instruction-detail?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (schwabMasterAccount === null)
            throw new Error("The parameter 'schwabMasterAccount' cannot be null.");
        else if (schwabMasterAccount !== undefined)
            url_ += "schwabMasterAccount=" + encodeURIComponent("" + schwabMasterAccount) + "&";
        if (schwabFormattedAccount === null)
            throw new Error("The parameter 'schwabFormattedAccount' cannot be null.");
        else if (schwabFormattedAccount !== undefined)
            url_ += "schwabFormattedAccount=" + encodeURIComponent("" + schwabFormattedAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountStandingInstructions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountStandingInstructions(<any>response_);
                } catch (e) {
                    return <Observable<StandingInstruction[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StandingInstruction[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountStandingInstructions(response: HttpResponseBase): Observable<StandingInstruction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandingInstruction[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SessionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    deleteSession(): Observable<void> {
        let url_ = this.baseUrl + "/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSession(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    downloadFileForTask(fileId: number, taskId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/tasks/{taskId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileForTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileForTask(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadFileForTask(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserSelf(): Observable<UserModel> {
        let url_ = this.baseUrl + "/users/self";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSelf(<any>response_);
                } catch (e) {
                    return <Observable<UserModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserSelf(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WistiaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProjectAssets(projectId: string): Observable<AcmMediaProject> {
        let url_ = this.baseUrl + "/wistia/projects/{projectId}/assets";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectAssets(<any>response_);
                } catch (e) {
                    return <Observable<AcmMediaProject>><any>_observableThrow(e);
                }
            } else
                return <Observable<AcmMediaProject>><any>_observableThrow(response_);
        }));
    }

    protected processGetProjectAssets(response: HttpResponseBase): Observable<AcmMediaProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AcmMediaProject>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getProjectAsset(assetId: string): Observable<AcmMediaProject> {
        let url_ = this.baseUrl + "/wistia/assets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectAsset(<any>response_);
                } catch (e) {
                    return <Observable<AcmMediaProject>><any>_observableThrow(e);
                }
            } else
                return <Observable<AcmMediaProject>><any>_observableThrow(response_);
        }));
    }

    protected processGetProjectAsset(response: HttpResponseBase): Observable<AcmMediaProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AcmMediaProject>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getCustomFormByName(form: string | undefined): Observable<AcmMediaProject> {
        let url_ = this.baseUrl + "/wistia/download?";
        if (form === null)
            throw new Error("The parameter 'form' cannot be null.");
        else if (form !== undefined)
            url_ += "form=" + encodeURIComponent("" + form) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomFormByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomFormByName(<any>response_);
                } catch (e) {
                    return <Observable<AcmMediaProject>><any>_observableThrow(e);
                }
            } else
                return <Observable<AcmMediaProject>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomFormByName(response: HttpResponseBase): Observable<AcmMediaProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AcmMediaProject>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrionConnectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTradingModelAggs(): Observable<OrionConnectTradingModelAggModel[]> {
        let url_ = this.baseUrl + "/orion/connect/trading-model-aggs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTradingModelAggs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTradingModelAggs(<any>response_);
                } catch (e) {
                    return <Observable<OrionConnectTradingModelAggModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionConnectTradingModelAggModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTradingModelAggs(response: HttpResponseBase): Observable<OrionConnectTradingModelAggModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionConnectTradingModelAggModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getSleeveRegistration(registrationId: number, accountId: number | undefined): Observable<OrionConnectSleeveRegistrationModel> {
        let url_ = this.baseUrl + "/orion/connect/sleeve-registration/{registrationId}?";
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSleeveRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSleeveRegistration(<any>response_);
                } catch (e) {
                    return <Observable<OrionConnectSleeveRegistrationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionConnectSleeveRegistrationModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetSleeveRegistration(response: HttpResponseBase): Observable<OrionConnectSleeveRegistrationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionConnectSleeveRegistrationModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrionEclipseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccountDetails(accountId: number | undefined): Observable<OrionEclipseAccountDetailModel[]> {
        let url_ = this.baseUrl + "/orion/eclipse/account?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountDetails(<any>response_);
                } catch (e) {
                    return <Observable<OrionEclipseAccountDetailModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionEclipseAccountDetailModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountDetails(response: HttpResponseBase): Observable<OrionEclipseAccountDetailModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionEclipseAccountDetailModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getAccountTransactions(accountId: number | undefined, eclipseAccountId: number | undefined, daySpan: number | undefined): Observable<OrionEclipseAccountTransactionsResponseModel[]> {
        let url_ = this.baseUrl + "/orion/eclipse/account/transactions?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (eclipseAccountId === null)
            throw new Error("The parameter 'eclipseAccountId' cannot be null.");
        else if (eclipseAccountId !== undefined)
            url_ += "eclipseAccountId=" + encodeURIComponent("" + eclipseAccountId) + "&";
        if (daySpan === null)
            throw new Error("The parameter 'daySpan' cannot be null.");
        else if (daySpan !== undefined)
            url_ += "daySpan=" + encodeURIComponent("" + daySpan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountTransactions(<any>response_);
                } catch (e) {
                    return <Observable<OrionEclipseAccountTransactionsResponseModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionEclipseAccountTransactionsResponseModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountTransactions(response: HttpResponseBase): Observable<OrionEclipseAccountTransactionsResponseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionEclipseAccountTransactionsResponseModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getAccountHoldings(accountId: number | undefined, eclipseAccountId: number | undefined): Observable<OrionEclipseAccountHoldingsResponseModel[]> {
        let url_ = this.baseUrl + "/orion/eclipse/account/holdings?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (eclipseAccountId === null)
            throw new Error("The parameter 'eclipseAccountId' cannot be null.");
        else if (eclipseAccountId !== undefined)
            url_ += "eclipseAccountId=" + encodeURIComponent("" + eclipseAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountHoldings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountHoldings(<any>response_);
                } catch (e) {
                    return <Observable<OrionEclipseAccountHoldingsResponseModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionEclipseAccountHoldingsResponseModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountHoldings(response: HttpResponseBase): Observable<OrionEclipseAccountHoldingsResponseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionEclipseAccountHoldingsResponseModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getModels(): Observable<OrionEclipseModelListResponseModel[]> {
        let url_ = this.baseUrl + "/orion/eclipse/models";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModels(<any>response_);
                } catch (e) {
                    return <Observable<OrionEclipseModelListResponseModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionEclipseModelListResponseModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetModels(response: HttpResponseBase): Observable<OrionEclipseModelListResponseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionEclipseModelListResponseModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getSecurities(search: string | undefined, top: number | null | undefined): Observable<OrionEclipseSecurityListResponseModel[]> {
        let url_ = this.baseUrl + "/orion/eclipse/securities?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (top !== undefined && top !== null)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurities(<any>response_);
                } catch (e) {
                    return <Observable<OrionEclipseSecurityListResponseModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionEclipseSecurityListResponseModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecurities(response: HttpResponseBase): Observable<OrionEclipseSecurityListResponseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionEclipseSecurityListResponseModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getPortfolioHoldings(portfolioId: number, accountId: number | undefined): Observable<OrionEclipseAccountHoldingsResponseModel[]> {
        let url_ = this.baseUrl + "/orion/eclipse/portfolio/{portfolioId}/holdings?";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortfolioHoldings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortfolioHoldings(<any>response_);
                } catch (e) {
                    return <Observable<OrionEclipseAccountHoldingsResponseModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionEclipseAccountHoldingsResponseModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPortfolioHoldings(response: HttpResponseBase): Observable<OrionEclipseAccountHoldingsResponseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionEclipseAccountHoldingsResponseModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }

    getPortfolio(portfolioId: number, accountId: number | undefined): Observable<OrionEclipsePortfolioDetailModel> {
        let url_ = this.baseUrl + "/orion/eclipse/portfolio/{portfolioId}?";
        if (portfolioId === undefined || portfolioId === null)
            throw new Error("The parameter 'portfolioId' must be defined.");
        url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortfolio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortfolio(<any>response_);
                } catch (e) {
                    return <Observable<OrionEclipsePortfolioDetailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrionEclipsePortfolioDetailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetPortfolio(response: HttpResponseBase): Observable<OrionEclipsePortfolioDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrionEclipsePortfolioDetailModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(<any>null);
    }
}

export interface AccountRequestDetailModel {
    accountRequestId: number;
    accountRequestTypeId: number;
    accountRequestType: string;
    agentId: number;
    investmentAccountId: number;
    investmentAccountNumber: string;
    custodian: string;
    investmentAccountType: string;
    investmentAccountModel: string;
    isSolicited: boolean | undefined;
    notes: string;
    clients: AccountClientModel[];
    sleeves: SleeveModel[];
    currentSleeves: SleeveModel[];
    sells: AccountRequestTradeOrderModel[];
    buys: AccountRequestTradeOrderModel[];
    releasedCash: AccountRequestTradeOrderModel[];
    customHoldings: AccountRequestCustomHoldingModel[];
    soldValue: number;
    cashReleasedValue: number;
    customHoldingsValue: number;
    investable: number;
    totalValue: number;
    status: string;
    statusDate: Date;
    statusId: number;
    statusNote: string;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    noteHistory: RequestNoteModel[];
    contribution: AccountRequestContributionFundingModel;
    distribution: AccountRequestDistributionFundingModel;
    payee: AccountRequestPayeeModel;
}

export interface AccountClientModel {
    firstName: string;
    lastName: string;
    id: number;
}

export interface SleeveModel {
    investmentAccountModel: string;
    investmentAccountModelID: number | undefined;
    amount: number;
    accountTotalFee: number;
    targetPercent: number | undefined;
    distributionPercent: number | undefined;
    contributionPercent: number | undefined;
    isNew: boolean | undefined;
    customHoldings: CustomHoldingModel[];
}

export interface CustomHoldingModel {
    tradeInstructionOption: string;
    amount: number;
    symbol: string;
}

export interface AccountRequestTradeOrderModel {
    tradeActionID: number;
    ticker: string;
    description: string;
    quantity: number | undefined;
    estimatedValue: number | undefined;
    price: number | undefined;
    orionEclipseSecurityID: number | undefined;
    orionEclipseSecurityTypeID: number | undefined;
}

export interface AccountRequestCustomHoldingModel {
    ticker: string;
    description: string;
    shares: number | undefined;
    estimatedValue: number | undefined;
    price: number | undefined;
    doNotTrade: boolean;
    orionEclipseSecurityID: number | undefined;
    isCash: boolean | undefined;
}

export interface FileModel {
    fileID: number;
    fileName: string;
    createdOn: Date | undefined;
    createdByUser: string;
    createdByUserName: string;
}

export interface RequestNoteModel {
    investmentAccountDistributionRequestStatusXRefID: number | undefined;
    statusID: number | undefined;
    internalStatus: string;
    externalStatus: string;
    noteID: number | undefined;
    note: string;
    createdOn: Date | undefined;
    createdByUser: string;
    createdByUserName: string;
}

export interface AccountRequestContributionFundingModel {
    amount: number | undefined;
    deliveryMethodID: number;
    deliveryMethod: string;
    deliveryFrequencyID: number;
    deliveryFrequency: string;
    deliveryInstruction: string;
    deliveryStartDate: Date | undefined;
    isOvernightDelivery: boolean;
    hasIaAuthority: boolean | undefined;
    sleeves: AccountRequestFundingSleeveModel[];
}

export interface AccountRequestFundingSleeveModel {
    investmentAccountModelID: number | undefined;
    investmentAccountModel: string;
    accountNumber: string;
    amount: number | undefined;
    percent: number | undefined;
}

export interface AccountRequestDistributionFundingModel {
    grossAmount: number | undefined;
    netAmount: number | undefined;
    federalTaxPercent: number | undefined;
    stateTaxPercent: number | undefined;
    isCloseAccount: boolean;
    isCloseDateBilled: boolean;
    deliveryMethodID: number;
    deliveryMethod: string;
    deliveryFrequencyID: number;
    deliveryFrequency: string;
    deliveryInstruction: string;
    deliveryStartDate: Date | undefined;
    isOvernightDelivery: boolean;
    hasIaAuthority: boolean | undefined;
    sleeves: AccountRequestFundingSleeveModel[];
}

export interface AccountRequestPayeeModel {
    deliveryRecipientTypeID: number;
    deliveryRecipientType: string;
    payeeName: string;
    streetAddress: string;
    addressContinued: string;
    city: string;
    state: string;
    zip: string;
}

export interface DeliveryOptionsModel {
    methods: DeliveryMethodOptionModel[];
    frequencies: DeliveryFrequencyOptionModel[];
    recipientTypes: DeliveryRecipientTypeOptionModel[];
}

export interface DeliveryMethodOptionModel {
    id: number;
    name: string;
    allowedForContribution: boolean;
    allowedForDistribution: boolean;
    usesBankAccount: boolean;
    usesAddressBook: boolean;
    allowsOvernightDelivery: boolean;
    newRecipientRequiresDocument: boolean;
    newRecipientRequiresPayee: boolean;
    transactionType: string;
}

export interface DeliveryFrequencyOptionModel {
    id: number;
    name: string;
    isOneTime: boolean;
}

export interface DeliveryRecipientTypeOptionModel {
    id: number;
    name: string;
    isThirdParty: boolean;
}

/** The Reallocation V2 wizard's submit payload. Every collection is non-nullable and always sent, empty when there is nothing to say. The payload's SHAPE must not depend on which feature flags happen to be on: a flag flip that changed the contract would be invisible here and would surface as missing data in CRM. CurrentModelAllocations is the sleeves the account already had when the wizard loaded. Without it ModelAllocations cannot be read as a change — "put 60% in Model X" gives no way to tell a re-weight from a brand-new sleeve. Empty is stored as "not recorded" rather than "no sleeves"; the two are different claims. ReleasedCash is the custodial cash the advisor freed on step 1. Sent as its own collection because it files under its own TradeAction (4, Cash) rather than as a sell — see . Always sent, empty when nothing was freed, like every other collection here. AccountRequestTypeID selects which request this is — 1 Initial Account, 2 Reallocation, 3 Contribution, 4 Distribution. One wizard, one endpoint and one CRM writer serve all four, and this is the only field that tells them apart: it becomes req.AccountRequest.AccountRequestTypeID, picks the CRM task category, and names the request in the trade team's queue. Deliberately has no default, so every caller has to say which it means. Contribution / Distribution are the ONLY type-specific part of this payload, and exactly one of them is present on types 3 and 4 respectively, neither on types 1 and 2. The pairing is enforced in the controller and again in CRM. They are optional here — rather than a separate payload per type — because everything else is shared, and three near-identical contracts is how a change like IsCash becomes three edits and one silent omission. Distinct from AccountRequestReallocationModelBase, which is v1's and targets the legacy CRM tables. IsSolicited is NULLABLE, and [Required] is gone with it (ACMTECH-1014). The portal stopped asking who initiated the request, so it sends null — and [Required] bool rejected that at model binding with "The JSON value could not be converted ... Path: $.isSolicited". A non-nullable bool also cannot represent what the column now holds, which is "not asked": false means the client asked for the trade and true means the advisor did. WARNING: [Required] on a non-nullable bool was never doing anything — a value type is always present, so the attribute could not fail. On bool? it WOULD fail, reinstating exactly the bug it is being removed for. Do not put it back. */
export interface AccountRequestV2ModelBase {
    investmentAccountID: number;
    isSolicited: boolean | undefined;
    accountRequestTypeID: number;
    orionEclipsePortfolioID: number | undefined;
    orionConnectRegistrationID: number | undefined;
    sells: AccountRequestV2Sell[];
    buys: AccountRequestV2Buy[];
    releasedCash: AccountRequestV2ReleasedCash[];
    customHoldings: AccountRequestV2CustomHolding[];
    modelAllocations: AccountRequestV2ModelAllocation[];
    currentModelAllocations: AccountRequestV2ModelAllocation[];
    snapshot: AccountRequestV2Snapshot | undefined;
    notes: string | undefined;
    contribution: AccountRequestV2Contribution | undefined;
    distribution: AccountRequestV2Distribution | undefined;
    payee: AccountRequestV2Payee | undefined;
}

/** A position being sold (→ req.TradeOrder, TradeOrderUnitID 1 / Shares). Which TradeAction it is filed under depends on IsSellAll. */
export interface AccountRequestV2Sell {
    ticker: string | undefined;
    description: string | undefined;
    sharesToSell: number | undefined;
    soldValue: number | undefined;
    price: number | undefined;
    orionEclipseSecurityID: number | undefined;
    priceAsOf: Date | undefined;
    isSellAll: boolean | undefined;
    orionEclipseSecurityTypeID: number | undefined;
}

/** A security being bought (→ req.TradeOrder, TradeActionID 1 / Shares). Shares only — the wizard does not accept dollar amounts, matching sells. */
export interface AccountRequestV2Buy {
    ticker: string | undefined;
    description: string | undefined;
    sharesToBuy: number | undefined;
    estimatedValue: number | undefined;
    price: number | undefined;
    orionEclipseSecurityID: number | undefined;
    priceAsOf: Date | undefined;
    orionEclipseSecurityTypeID: number | undefined;
}

/** Custodial cash the advisor freed on step 1 to fund the request (→ req.TradeOrder, TradeActionID 4 / Cash). */
export interface AccountRequestV2ReleasedCash {
    ticker: string | undefined;
    description: string | undefined;
    releasedValue: number | undefined;
    orionEclipseSecurityID: number | undefined;
    orionEclipseSecurityTypeID: number | undefined;
    priceAsOf: Date | undefined;
}

/** A line in the resulting Custom Holdings sleeve (→ req.CustomHolding): positions kept, plus anything bought, aggregated per security, plus the protected-cash PROTECTED CASH line. */
export interface AccountRequestV2CustomHolding {
    ticker: string | undefined;
    description: string | undefined;
    keptShares: number | undefined;
    keptValue: number | undefined;
    price: number | undefined;
    isDoNotTrade: boolean | undefined;
    orionEclipseSecurityID: number | undefined;
    priceAsOf: Date | undefined;
    orionEclipseSecurityTypeID: number | undefined;
    isCash: boolean | undefined;
}

/** A model sleeve + its allocation percentages (→ req.AllocationSleeve). Used for both the requested allocation and the account's current one; which it is comes from the collection it arrives in, not from anything on the row. */
export interface AccountRequestV2ModelAllocation {
    investmentAccountModelID: number | undefined;
    allocatedValue: number | undefined;
    targetPercent: number | undefined;
    distributionPercent: number | undefined;
    contributionPercent: number | undefined;
    orionConnectAccountID: number | undefined;
    orionConnectModelAggID: number | undefined;
    accountNumber: string | undefined;
    isNew: boolean | undefined;
    isSMA: boolean | undefined;
    cashRaised: number | undefined;
}

/** The "before" picture the request was built against (→ req.AccountRequestSnapshot). Supplied by the wizard rather than rebuilt server-side: re-reading Orion here would produce a different picture at a different time, which is the very thing this exists to pin down. */
export interface AccountRequestV2Snapshot {
    capturedOn: Date | undefined;
    valueBasis: string | undefined;
    json: string | undefined;
}

/** A contribution's funding and delivery (→ req.Contribution). Type 3 only. */
export interface AccountRequestV2Contribution {
    amount: number | undefined;
    deliveryMethodID: number | undefined;
    deliveryFrequencyID: number | undefined;
    deliveryInstruction: string | undefined;
    deliveryStartDate: Date | undefined;
    isOvernightDelivery: boolean | undefined;
    hasIaAuthority: boolean | undefined;
    sleeves: AccountRequestV2FundingSleeve[] | undefined;
}

/** One model sleeve's share of a contribution or distribution (→ req.ContributionSleeve / req.DistributionSleeve). */
export interface AccountRequestV2FundingSleeve {
    investmentAccountModelID: number | undefined;
    accountNumber: string | undefined;
    amount: number | undefined;
    percent: number | undefined;
}

/** A distribution's funding and delivery (→ req.Distribution). Type 4 only. */
export interface AccountRequestV2Distribution {
    grossAmount: number | undefined;
    netAmount: number | undefined;
    federalTaxPercent: number | undefined;
    stateTaxPercent: number | undefined;
    priorFederalTaxPercent: number | undefined;
    priorStateTaxPercent: number | undefined;
    isCloseAccount: boolean | undefined;
    isCloseDateBilled: boolean | undefined;
    deliveryMethodID: number | undefined;
    deliveryFrequencyID: number | undefined;
    deliveryInstruction: string | undefined;
    deliveryStartDate: Date | undefined;
    isOvernightDelivery: boolean | undefined;
    hasIaAuthority: boolean | undefined;
    sleeves: AccountRequestV2FundingSleeve[] | undefined;
}

/** Who a check is made out to, whose address it is, and where it is posted (→ req.AccountRequestPayee). */
export interface AccountRequestV2Payee {
    deliveryRecipientTypeID: number | undefined;
    payeeName: string | undefined;
    streetAddress: string | undefined;
    addressContinued: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
}

export interface TaskFilesListModel {
    taskID: number;
    investmentAccountID: number;
    requestType: string;
    recipientType: string;
    taskDescription: string;
    investmentAccountModel: string;
    custodian: string;
    accountNumber: string;
    advisors: AccountAdvisorModel[];
    clients: AccountClientModel[];
    files: FileModel[];
    createdOn: Date;
    createdBy: string;
}

export interface AccountAdvisorModel {
    agentID: number;
    crd: string;
    firstName: string;
    lastName: string;
}

export interface AccountMessageModel {
    recipientID: number;
    agentID: number;
    accountID: number;
    onBehalfOfRequest: AttachedRequest | undefined;
    notes: string | undefined;
}

export interface AttachedRequest {
    requestId: number | undefined;
    taskId: number | undefined;
    requestType: AccountMessageRequestTypeEnum | undefined;
}

/** Mirrors CRM's RequestTypeEnum (Models/API/InvestmentAccountMessageModel.cs) - CRM uses it to resolve which request a message was sent "on behalf of" and therefore which task to attach the note and files to. Append new members; the two enums must stay aligned. */
export enum AccountMessageRequestTypeEnum {
    Distribution = "Distribution",
    ModelAllocation = "ModelAllocation",
    OrionServiceRequest = "OrionServiceRequest",
    PlanningDesk = "PlanningDesk",
    GeneralAccount = "GeneralAccount",
    InitialAccount = "InitialAccount",
}

export interface PlanningDeskMessageModel {
    recipientID: number;
    agentID: number;
    portfolioAnalysisRequestID: number;
    notes: string | undefined;
}

export interface AgentModel {
    agentID: number;
    crd: string;
    firstName: string;
    middleName: string;
    lastName: string;
    agentStatus: string;
}

export interface ClientModel {
    clientID: number;
    personID: number;
    firstName: string;
    middleName: string;
    lastName: string;
    nickName: string;
}

export interface AccountRequestCloseModelBase {
    investmentAccountID: number;
    isSolicited: boolean | undefined;
    requestDetail: RequestDetailClose;
}

export interface RequestDetailClose {
    isCloseDateBilled: boolean;
    deliveryMethodID: number;
    isOvernightCheckDelivery: boolean | undefined;
    wireDeliveryOptionID: number | undefined;
    deliveryInstruction: string | undefined;
    hasIaAuthority: boolean | undefined;
    federalTax: number;
    stateTax: number;
    changeTaxWithholdings: boolean;
    fromAccountNumber: string | undefined;
    notes: string;
}

export interface CloseAccountRequestDetailModel {
    agentId: number;
    investmentAccountId: number;
    investmentAccountNumber: string;
    custodian: string;
    investmentAccountType: string;
    stateTax: number | undefined;
    federalTax: number | undefined;
    changeTaxWithholdings: boolean | undefined;
    grossAmount: number | undefined;
    notes: string;
    method: string;
    deliveryInstruction: string;
    frequency: string;
    isCloseDateBilled: boolean;
    clients: AccountClientModel[];
    status: string;
    beginsOn: Date | undefined;
    statusDate: Date;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    statusId: number;
    statusNote: string;
    noteHistory: RequestNoteModel[];
}

export interface AccountRequestContributionModelBase {
    investmentAccountID: number;
    isSolicited: boolean | undefined;
    requestDetail: RequestDetailContribution;
    tradeInstruction: TradeInstruction | undefined;
}

export interface RequestDetailContribution {
    frequencyID: number;
    grossAmount: number;
    startDate: Date | undefined;
    deliveryMethodID: number;
    deliveryInstruction: string | undefined;
    hasIaAuthority: boolean | undefined;
    notes: string | undefined;
    isCustomAllocation: boolean;
    protectedCash: ProtectedCashModel | undefined;
    requestSleeves: RequestSleeve[];
}

export interface ProtectedCashModel {
    amount: number;
    fee: number;
}

export interface RequestSleeve {
    accountNumber: string | undefined;
    amount: number;
    investmentAccountModelID: number | undefined;
    isNewSleeve: boolean | undefined;
}

export interface TradeInstruction {
    tradeInstructionID: number;
    notes: string | undefined;
    tradeInstructionOptions: TradeInstructionOption[];
}

export interface TradeInstructionOption {
    tradeInstructionOptionID: number;
    symbol: string;
    amount: number | undefined;
}

export interface ContributionRequestDetailModel {
    agentId: number;
    investmentAccountId: number;
    investmentAccountNumber: string;
    custodian: string;
    investmentAccountType: string;
    stateTax: number | undefined;
    federalTax: number | undefined;
    changeTaxWithholdings: boolean | undefined;
    grossAmount: number | undefined;
    notes: string;
    method: string;
    deliveryInstruction: string;
    frequency: string;
    clients: AccountClientModel[];
    sleeves: SleeveModel[];
    tradeInstructions: string;
    status: string;
    protectedCashAmount: number | undefined;
    beginsOn: Date | undefined;
    statusDate: Date;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    statusId: number;
    statusNote: string;
    noteHistory: RequestNoteModel[];
}

export interface CustodianModel {
    custodianID: number;
    businessID: number;
    name: string;
}

export interface AccountRequestDistributionModelBase {
    investmentAccountID: number;
    isSolicited: boolean | undefined;
    requestDetail: RequestDetailDistribution;
    tradeInstruction: TradeInstruction | undefined;
}

export interface RequestDetailDistribution {
    frequencyID: number;
    grossAmount: number;
    startDate: Date | undefined;
    deliveryMethodID: number;
    isOvernightCheckDelivery: boolean | undefined;
    wireDeliveryOptionID: number | undefined;
    deliveryInstruction: string | undefined;
    hasIaAuthority: boolean | undefined;
    fromAccountNumber: string | undefined;
    federalTax: number;
    stateTax: number;
    changeTaxWithholdings: boolean;
    notes: string | undefined;
    isCustomAllocation: boolean;
    requestSleeves: RequestSleeve[];
}

export interface DistributionRequestDetailModel {
    agentId: number;
    investmentAccountId: number;
    investmentAccountNumber: string;
    custodian: string;
    investmentAccountType: string;
    stateTax: number | undefined;
    federalTax: number | undefined;
    changeTaxWithholdings: boolean | undefined;
    grossAmount: number | undefined;
    notes: string;
    method: string;
    deliveryInstruction: string;
    frequency: string;
    clients: AccountClientModel[];
    sleeves: SleeveModel[];
    tradeInstructions: string;
    trades: TradeModel[];
    status: string;
    beginsOn: Date | undefined;
    statusDate: Date;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    statusId: number;
    statusNote: string;
    noteHistory: RequestNoteModel[];
}

export interface TradeModel {
    instruction: string;
    amount: number;
    symbol: string;
}

export interface FirstMfaSetupPostModel {
    phoneNumber: string;
}

export interface FirstMfaVerificationPostModel {
    mfaCode: string;
    rememberMe: boolean;
}

export interface PolicyByCrdListModel {
    agentName: string;
    policyID: number;
    policyNumber: string;
    clients: PolicyClientModel[];
    carrier: string;
    qualificationType: string;
    lineOfBusiness: string;
    product: string;
    faceAmount: number;
    premium: number;
    issuedPremium: number;
    currentValue: number;
    targetAmount: number;
    annualizedPremium: number;
    totalFirstYearPremium: number;
    status: string;
    statusDate: Date | undefined;
    inforceDate: Date | undefined;
    crdNumber: string;
}

export interface PolicyClientModel {
    firstName: string;
    lastName: string;
}

export interface AccountModel {
    advisors: AccountAdvisorModel[];
    clients: AccountClientModel[];
    investmentAccountID: number;
    custodian: string;
    custodianID: number;
    accountNumber: string;
    investmentAccountStatus: string;
    currentInvestmentAccountStageID: number | undefined;
    currentStage: string;
    currentStageDate: Date | undefined;
    currentStageID: number | undefined;
    openInvestmentAccountStageID: number | undefined;
    openStage: string;
    openStageDate: Date | undefined;
    title: string;
    title2: string;
    title3: string;
    investmentAccountType: string;
    investmentAccountModel: string;
    investmentAccountModelID: number | undefined;
    isMoneyLinkEnabled: boolean | undefined;
    federalTaxWithholding: number | undefined;
    stateTaxWithholding: number | undefined;
    acmFee: number | undefined;
    totalFee: number | undefined;
    accountValue: number | undefined;
    cashValue: number | undefined;
    repCode: string;
    schwabMasterAccount: number | undefined;
    schwabFormattedAccount: number | undefined;
    openedOn: Date | undefined;
    totalExpectedFunds: string;
    totalOutgoingTransfer: string;
    okToTrade: boolean;
    investmentAccountTradeStatusID: number;
    investmentAccountTradeStatus: string;
    sleeves: AccountSleeveModel[];
    tdSchwabAccountNumbers: TDSchwabAccountNumberMigrationModel[];
}

export interface AccountSleeveModel {
    investmentAccountModel: string;
    investmentAccountModelID: number | undefined;
    accountNumber: string;
    accountTotalFee: number;
    currentValue: number;
    cashValue: number;
    investmentAccountStatus: string;
}

export interface TDSchwabAccountNumberMigrationModel {
    accountNumber: string;
    schwabAccountNumber: string;
    tdAccountNumber: string;
}

export interface AccountListModel {
    agentID: number;
    agentFirstName: string;
    agentLastName: string;
    crd: string;
    clientID: number;
    clientFirstName: string;
    clientLastName: string;
    investmentAccounts: AccountModel[];
}

export interface InvestmentAccountTypeModel {
    id: number;
    name: string;
}

export interface PaperUploadClientModel {
    firstName: string;
    lastName: string;
    email: string;
    agentID: number;
}

export interface PaperUploadAccountModel {
    investmentAccountModelID: number;
    investmentAccountTypeID: number;
    custodianID: number;
    clientID: number | undefined;
    note: string;
}

export interface AccountSearchListModel {
    investmentAccountID: number;
    custodian: string;
    accountNumber: string;
    accountValue: number | undefined;
    cashValue: number | undefined;
    clients: string;
    investmentAccountType: string;
    investmentAccountModel: string;
    advisors: AccountAdvisorModel[];
}

export interface InvestmentModel {
    id: number;
    name: string;
    moneyManager: string;
    isSma: boolean;
    orionConnectModelAggID: number | undefined;
}

/** Represents the 3 possible non-failure results. */
export interface LoginResponseModel {
    type: LoginResponseType;
}

export enum LoginResponseType {
    Success = "Success",
    RequiresMfaVerification = "RequiresMfaVerification",
    RequiresMfaSetup = "RequiresMfaSetup",
}

/** Similar to LoginResponseModel, represents the different possible failure response types. Since NSwag does not yet support OneOf we can't use inheritance here, so instead we just combine the fields we might need to use into this model. */
export interface LoginFailureResponseModel {
    type: LoginFailureResponseType;
    lockedUntil: Date | undefined;
}

export enum LoginFailureResponseType {
    Locked = "Locked",
    Disabled = "Disabled",
    InvalidCredentials = "InvalidCredentials",
}

export interface LoginPostModel {
    userNameOrEmail: string;
    password: string;
}

export interface MfaVerificationPostModel {
    mfaCode: string;
    rememberMe: boolean;
}

export interface OrionServiceRequestModel2 {
    orionServiceRequestID: number;
    agentId: number;
    investmentAccountId: number;
    investmentAccountNumber: string;
    custodian: string;
    investmentAccountType: string;
    clients: AccountClientModel[];
    requestDetails: RequestDetailModel[];
    requestComments: RequestCommentModel[];
    status: string;
    statusDate: Date;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    statusId: number;
    statusNote: string;
    noteHistory: RequestNoteModel[];
}

export interface RequestDetailModel {
    requestType: string;
    requestSubType: string;
    contributionAmount: number | undefined;
    distributionAmount: number | undefined;
    setupOption: string;
    frequency: string;
    startDate: Date | undefined;
}

export interface RequestCommentModel {
    note: string;
    createdon: Date;
}

export interface PasswordResetRequestModel {
    userNameOrEmail: string;
}

export enum CreateNewPasswordResultFailureType {
    InvalidPassword = "InvalidPassword",
    NotFound = "NotFound",
    AlreadyCompleted = "AlreadyCompleted",
    Expired = "Expired",
    NoMfaDevice = "NoMfaDevice",
}

export interface CreateNewPasswordModel {
    password: string;
}

export interface MfaVerifyModel {
    mfaCode: string;
}

export interface UserPermissionModel {
    permissionID: number;
    permissionName: string;
}

export interface PlanningDeskModelBase {
    agentID: number;
    planningDeskCategoryID: number;
    meetingOn: Date | undefined;
    planningDeskDetails: PlanningDeskDetailsModel[];
}

export interface PlanningDeskDetailsModel {
    accountOwner: string;
    proposalTypeID: number | undefined;
    investmentAccountTypeID: number | undefined;
    currentAccountValue: number | undefined;
    notes: string;
}

export interface PlanningDeskRequestDetailModel {
    agentId: number;
    portfolioAnalysisRequestID: number;
    client: string;
    requestType: string;
    nextAppointment: Date | undefined;
    notes: string;
    accounts: PlanningDeskAccountModel[];
    status: string;
    statusDate: Date | undefined;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    statusId: number;
    statusNote: string;
    noteHistory: RequestNoteModel[];
}

export interface PlanningDeskAccountModel {
    investmentAccountType: string;
    currentAccountValue: number;
    clientFee: number;
}

export interface AccountRequestReallocationModelBase {
    investmentAccountID: number;
    isSolicited: boolean | undefined;
    notes: string | undefined;
    requestSleeves: RequestSleeve[];
    tradeInstruction: TradeInstruction | undefined;
}

export interface ReallocationRequestDetailModel {
    agentId: number;
    investmentAccountId: number;
    investmentAccountNumber: string;
    custodian: string;
    notes: string;
    investmentAccountType: string;
    clients: AccountClientModel[];
    sleeves: SleeveModel[];
    tradeInstructions: string;
    trades: TradeModel[];
    status: string;
    statusDate: Date;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    statusId: number;
    statusNote: string;
    noteHistory: RequestNoteModel[];
}

export interface RegistrationDetailResponseModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
}

export enum CompleteRegistrationFailureType {
    InvalidPassword = "InvalidPassword",
    NotFound = "NotFound",
    AlreadyCompleted = "AlreadyCompleted",
    Expired = "Expired",
}

export interface CompleteRegistrationModel {
    password: string;
}

export interface RequestModel {
    advisors: AccountAdvisorModel[];
    agentId: number;
    category: string;
    subCategory: string;
    investmentAccountId: number | undefined;
    investmentAccountUploadId: number | undefined;
    investmentAccountDistributionRequestId: number | undefined;
    investmentAccountModelRequestId: number | undefined;
    orionServiceRequestId: number | undefined;
    portfolioAnalysisRequestId: number | undefined;
    custodian: string;
    investmentAccountModel: string;
    investmentAccountNumber: string;
    clients: AccountClientModel[];
    status: string;
    statusDate: Date;
    statusId: number;
    taskId: number | undefined;
    accountRequestId: number | undefined;
    accountRequestTypeId: number | undefined;
}

export interface GeneralAccountRequestDetailModel {
    agentId: number;
    category: string;
    subCategory: string;
    investmentAccountId: number | undefined;
    investmentAccountUploadId: number | undefined;
    custodian: string;
    investmentAccountType: string;
    investmentAccountModel: string;
    investmentAccountNumber: string;
    notes: string;
    advisors: AccountAdvisorModel[];
    clients: AccountClientModel[];
    status: string;
    statusDate: Date;
    statusId: number;
    statusNote: string;
    submittedDate: Date;
    submittedBy: string;
    files: FileModel[];
    noteHistory: RequestNoteModel[];
}

export interface SchwabAccountDetailModel {
    accountNumber: number;
    profileList: ProfilesListAttributesModel | undefined;
    balances: BalancesDetailAttributesModel | undefined;
    positions: PositionsDetailAttributesModel | undefined;
}

export interface ProfilesListAttributesModel {
    profiles: ProfilesListModel[];
    errors: InvalidAccountsModel;
}

export interface ProfilesListModel {
    formattedAccount: string;
    accountRegistrationType: string;
    accountTitle: string;
    establishedDate: string;
    linkedToMasterDate: string;
    primaryEmailAddress: string;
    emailAddress: string;
    homePhone: string;
    mobilePhone: string;
    businessPhone: string;
    mailingAddress: ProfilesListMailingAddressModel;
    householdGroupId: string;
    householdGroupBalance: string;
    commissionNotes: string;
    isIip: boolean;
    enrolledInTrustAssetServices: boolean;
    hasWebAccess: boolean;
    eStatementConsentDate: string;
    holders: ProfilesListHolderModel[];
}

export interface ProfilesListMailingAddressModel {
    address: string;
    city: string;
    stateZip: string;
    country: string;
}

export interface ProfilesListHolderModel {
    accountHolderId: number;
    role: string;
    beneficiaryAssetPercentage: string;
    name: string;
    emailAddress: string;
    mobileAccess: string;
}

export interface InvalidAccountsModel {
    invalidAccounts: string[];
}

export interface BalancesDetailAttributesModel {
    formattedAccount: string;
    totalAccountValue: number;
    totalMarketValue: number;
    totalAccountBalance: number;
    totalAvailableToWithdraw: number;
    accountNetWorth: number;
    cash: number;
    cashAndCashInvestments: number;
    cashAvailableToTrade: number;
    bankSweepName: string;
    bankSweep: number;
    marginBalance: number;
    shortBalance: number;
    moneyMarketFund: number;
    moneyMarketFundName: string;
    settledFunds: number;
    securitiesMarketValueLong: number;
    securitiesMarketValueShort: number;
    longSecuritiesMarketValueNonMarginable: number;
    securitiesMarketValueLongNonMargin: number;
    securitiesMarketValueLongMargin: number;
    securitiesMarketValueShortNonMargin: number;
    securitiesMarketValueShortMargin: number;
    optionsMarketValueLongNonMargin: number;
    optionsMarketValueLongMargin: number;
    optionsMarketValueShortNonMargin: number;
    optionsMarketValueShortMargin: number;
    isMarginEnabled: boolean;
    moneyDue: number;
    equities: number;
    equityPercent: number;
    equitiesIncludingMarketOptionValue: number;
    marginBuyingPower: number;
    nonMarginableSecurities: number;
    nonMarginableMutualFunds: number;
    pennyStocks: number;
    treasuries: number;
    governmentAgencies: number;
    municipalBonds: number;
    nonConvertibleCorporate: number;
    convertibleCorporate: number;
    optionsMarketValueLong: number;
    shortOptions: number;
    dayTradeBuyingPower: number;
    smaFedCall: number;
    marginInterestMonthToDate: number;
    marginEquity: number;
    optionRequirement: number;
    monthEndDividendInterestPayout: number;
    paaEligibleMarketValue: number;
    paaExcessDeficiency: number;
    paaSetupAmount: number;
}

export interface PositionsDetailAttributesModel {
    positions: PositionsDetailPositionsModel[];
    totalPositions: PositionsDetailTotalPositionsModel;
}

export interface PositionsDetailPositionsModel {
    formattedAccount: string;
    type: string;
    securityName: string;
    symbol: string;
    securityNumber: number;
    securityType: string;
    quantity: number;
    quotedPrice: number;
    priceStaleStatus: string;
    marketValue: number;
    dayChange: string;
    percentageofAccountAssetsLong: number;
    areCapitalGainsReinvested: boolean;
    areDividendsReinvested: boolean;
    isDividendReinvestEditable: boolean;
    itemIssueId: number;
    suffix: number;
}

export interface PositionsDetailTotalPositionsModel {
    totalAccountValue: number;
    totalShortBalance: number;
    totalCashAndCashInvestments: number;
    totalMarketValue: number;
    totalDayChange: number;
    totalDayChangePercentage: number;
}

/** One standing instruction on a Schwab account — an authorization to move money to a named counterparty, flattened from their two-call detail payload. */
export interface StandingInstruction {
    bankAccountNumber: string | undefined;
    bankName: string | undefined;
    direction: string | undefined;
    transactionType: string | undefined;
    displayValue: string | undefined;
    hasIaAuthority: boolean | undefined;
    payeeName: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    address3: string | undefined;
    countryCode: string | undefined;
}

export interface UserModel {
    userId: number;
    firstName: string;
    lastName: string;
    email: string;
}

export interface AcmMediaProject {
    projectId: string;
    name: string;
    content: AcmMediaSection[];
}

export interface AcmMediaSection {
    sectionId: string;
    name: string;
    assets: AcmMediaAsset[];
}

export interface AcmMediaAsset {
    assetId: string;
    name: string;
    mediaType: AcmMediaFileType;
}

export enum AcmMediaFileType {
    File = "File",
    Video = "Video",
    Website = "Website",
}

export interface OrionConnectTradingModelAggModel {
    id: number;
    name: string;
    isSystemMaintained: boolean | undefined;
    accountNumberSuffix: string;
    keepAlways: boolean | undefined;
    accountCount: number | undefined;
    value: number | undefined;
    sortOrder: number | undefined;
    color: string;
    eclipseFirmId: number | undefined;
    eclipseFirmIdsCsv: string;
    modelTags: string;
    tags: string[];
    eclipseModelId: number | undefined;
    minimumInvestmentAmount: number | undefined;
    billFeeSchedule: number | undefined;
    payoutSchedule: number | undefined;
    createdBy: string;
    editedBy: string;
    editedDate: Date | undefined;
    entityId: number | undefined;
    entityEnum: string;
    include: boolean | undefined;
    owned: boolean | undefined;
    canMaintain: boolean | undefined;
    modelAggTypeId: number | undefined;
    modelAggType: string;
    riskScore: number | undefined;
    proposalEnabled: boolean | undefined;
    advisoryWorldModel: boolean | undefined;
    hasManagerFactSheet: boolean | undefined;
    subAdvisorId: number | undefined;
    subAdvisorName: string;
    containsCommunityModel: boolean | undefined;
    communityModelId: number | undefined;
    modelAssetType: string;
    modelRiskCategory: string;
    modelAssetClass: string;
    modelStrategyType: string;
    taxManaged: boolean | undefined;
    isSociallyResponsible: boolean | undefined;
    morningstarId: string;
    isAstroEnabled: boolean | undefined;
    syncToAstro: boolean | undefined;
    details: OrionConnectTradingModelAggDetailModel[];
    hasSMAModel: boolean | undefined;
    strategistId: number | undefined;
    worstReturn: number | undefined;
    averageReturn: number | undefined;
    bestReturn: number | undefined;
    associatedModelAggId: number | undefined;
    astroTemplate: string;
    portfolioOverview: string;
    portfolioManagementTeam: string;
    excludeRebalanceSleeve: boolean | undefined;
    eclipseModelType: string;
    investmentObjectiveId: number | undefined;
}

export interface OrionConnectTradingModelAggDetailModel {
    modelId: number;
    modelName: string;
    weightPercent: number | undefined;
    managementStyle: string;
    managementStyleId: number | undefined;
    isSma: boolean | undefined;
    assetClassId: number | undefined;
    riskCategoryId: number | undefined;
}

export interface OrionConnectSleeveRegistrationModel {
    registrationId: number | undefined;
    custodialAccountNumber: string;
    isDoNotTrade: boolean | undefined;
    accountSleeves: OrionConnectAccountSleeveModel[];
}

export interface OrionConnectAccountSleeveModel {
    accountId: number | undefined;
    modelAgg: string;
    modelAggId: number | undefined;
    targetAllocation: number | undefined;
    distributionAllocation: number | undefined;
    contributionAllocation: number | undefined;
    targetBalanceType: string;
    minimumInvestmentAmount: number | undefined;
    currentValue: number | undefined;
    sleeveType: string;
    doNotTrade: boolean | undefined;
}

export interface OrionEclipseAccountDetailModel {
    id: number;
    accountId: string;
    name: string;
    accountNumber: string;
    model: string;
    modelId: number | undefined;
    portfolio: string;
    portfolioId: number | undefined;
    advisor: string;
    accountType: string;
    isSleeve: number | undefined;
    isDoNotBuySell: boolean;
    accountValue: OrionEclipseAccountValueModel;
    summarySection: OrionEclipseAccountSummaryModel;
    doNotTrade: string;
}

export interface OrionEclipseAccountValueModel {
    totalValueOn: string;
    totalValue: number | undefined;
    status: string;
    holdings: OrionEclipseAccountHoldingsModel[];
}

export interface OrionEclipseAccountHoldingsModel {
    securityName: string;
    securitySymbol: string;
    marketValue: number;
    unit: number;
    price: number;
    percentage: number;
    pendingValue: number;
}

export interface OrionEclipseAccountSummaryModel {
    grandTotal: number;
    totalValue: number;
    managedValue: number;
    excludedValue: number;
    totalCashValue: number;
    cashReserve: number;
    cashAvailable: number;
    setAsideCash: number;
    pendingCashValue: number;
}

export interface OrionEclipseAccountTransactionsResponseModel {
    id: number | undefined;
    accountNumber: string;
    transDate: Date | undefined;
    transAmount: number | undefined;
    navPrice: number | undefined;
    transactionDescription: string;
    productName: string;
    ticker: string;
    noUnits: number | undefined;
    type: string;
    transTime: string;
    assetId: number;
    cusip: string;
    notes: string;
    transTypeId: number | undefined;
    transactionSubTypeId: number | undefined;
    transactionSubTypeName: string;
    transactionSubTypeDescription: string;
    contributionCodeId: string;
    contributionCodeName: string;
    distributionCodeId: string;
    distributionCodeName: string;
    accountId: number | undefined;
    accountStatusId: number | undefined;
    managementStyle: string;
    payee: string;
    advisorNotes: string;
    state: string;
    settleDate: Date | undefined;
    tradeReferenceNumber: string;
    transactionLinkCode: string;
    createdBy: string;
    createdDate: Date | undefined;
    editedBy: string;
    editedDate: Date | undefined;
    registrationId: number | undefined;
    clientId: number | undefined;
    typeCode: string;
    brokerCode: string;
    accountType: string;
    fundFamily: string;
    custodian: string;
    count: number | undefined;
    registrationName: string;
    unitBalance: number | undefined;
    productId: number | undefined;
    performanceFeeBreak: boolean | undefined;
    financialType: string;
}

export interface OrionEclipseAccountHoldingsResponseModel {
    id: number | undefined;
    accountNumber: string;
    securityName: string;
    securitySymbol: string;
    price: number | undefined;
    shares: number | undefined;
    value: number | undefined;
    currentInPer: number | undefined;
    targetInPer: number | undefined;
    pendingValue: number | undefined;
    pendingInPer: number | undefined;
    excluded: string;
    isCash: string;
    inModel: string;
    pendingShares: number | undefined;
    isPlugged: number | undefined;
    isDeleted: number | undefined;
    createdOn: Date | undefined;
    createdBy: string;
    editedOn: Date | undefined;
    editedBy: string;
    accountId: number | undefined;
    assetCategoryName: string;
    assetClassName: string;
    assetSubClassName: string;
    securityId: number | undefined;
    securityTypeId: number | undefined;
    securityTypeName: string;
    lastTLHDate: Date | undefined;
    costAmount: number | undefined;
    unrealizedGainLoss: number | undefined;
    stUnrealizedGainLoss: number | undefined;
    ltUnrealizedGainLoss: number | undefined;
    depletionMethod: string;
}

export interface OrionEclipseModelListResponseModel {
    id: number;
    name: string;
    sleeveCount: number | undefined;
    portfolioCount: number | undefined;
    source: string;
    hasSubstitute: boolean | undefined;
    statusId: number | undefined;
    status: string;
    nameSpace: string;
    currentStatusId: number | undefined;
    tags: string;
    isDynamic: boolean | undefined;
    isSubstitutedForPortfolio: boolean | undefined;
    description: string;
    ownerUserId: number | undefined;
    ownerUser: string;
    managementStyleId: number | undefined;
    managementStyle: string;
    isCommunityModel: boolean | undefined;
    communityModelId: number | undefined;
    lastSyncDate: string;
    approvedByUserId: number | undefined;
    approvedByUser: string;
    isDeleted: boolean | undefined;
    createdOn: string;
    editedOn: string;
    teamId: number | undefined;
    modelTeamIds: string;
    teamName: string;
    teamNames: string;
    createdBy: string;
    editedBy: string;
    hasEditAccess: boolean;
    isMAC: boolean | undefined;
    needsUpdate: boolean | undefined;
    updateStatus: string;
    isSMA: boolean | undefined;
    isOptionTradingAllowed: boolean | undefined;
    astroTemplateId: string;
    modelAUM: number | undefined;
    sleeveSuffix: string;
    excludeRebalanceSleeve: boolean | undefined;
    modelTypeName: string;
    lastRebalanced: string;
    dateRebalanceRequested: string;
    needsRebalance: boolean | undefined;
}

export interface OrionEclipseSecurityListResponseModel {
    id: number | undefined;
    orionConnectExternalId: number | undefined;
    name: string;
    symbol: string;
    cusip: string;
    securityTypeId: number | undefined;
    securityType: string;
    price: number | undefined;
    priceDateTime: Date | undefined;
    statusId: number | undefined;
    status: string;
    isMultiAssetClass: number | undefined;
    isDeleted: number | undefined;
    hasCorporateSecurityAction: number | undefined;
    maintainInEclipse: number | undefined;
    isTradableMoneyMarket: boolean | undefined;
    assetCategoryId: number | undefined;
    assetCategory: string;
    assetClassId: number | undefined;
    assetClass: string;
    assetSubClassId: number | undefined;
    assetSubClass: string;
    custodialCash: number | undefined;
    createdOn: Date | undefined;
    createdBy: string;
    editedOn: Date | undefined;
    editedBy: string;
}

export interface OrionEclipsePortfolioDetailModel {
    id: number;
    needAnalytics: number | undefined;
    needAnalyticsStatus: string;
    needAnalyticsToTradeStatus: string;
    failedReason: string;
    isDeleted: number;
    isDisabled: number;
    createdBy: string;
    createdOn: Date | undefined;
    editedBy: string;
    editedOn: Date | undefined;
    analyticsEditedDate: Date | undefined;
    general: OrionEclipsePortfolioDetailGeneralModel;
    issues: OrionEclipsePortfolioDetailIssuesModel;
    teams: OrionEclipsePortfolioDetailTeamModel[];
    summary: OrionEclipsePortfolioDetailSummaryModel;
    disabledReason: string;
    orionConnectFirmId: number | undefined;
    portfolioGroupId: number | undefined;
}

export interface OrionEclipsePortfolioDetailGeneralModel {
    portfolioName: string;
    macStatus: number | undefined;
    sleevePortfolio: number | undefined;
    custodialAccountNumber: string;
    registrationId: number | undefined;
    sleeveStrategy: string;
    contributionMethod: string;
    distributionMethod: string;
    substitutedModelId: number | undefined;
    modelId: number | undefined;
    modelName: string;
    autoRebalance: string;
    monthAndDate: string;
    rebalanceTypeId: number;
    rebalanceType: string;
    rebalanceOptionId: number;
    rebalanceOption: string;
    rebalanceDay: number | undefined;
    lastRebalanceDate: Date | undefined;
    doNotTrade: boolean;
    tradingInstruction: string;
    sellEmphasisOn: number | undefined;
    buyEmphasisOn: number | undefined;
    tags: string;
    fixedIncomeTradeBlockDate: Date | undefined;
    pendingApprovalModelId: number | undefined;
    pendingApprovalModelName: string;
    sleeveStrategyAggregateId: string;
    sleeveStrategyAggregateName: string;
    lastTradedDate: Date | undefined;
    lastTLHDate: Date | undefined;
    sleeveDeviationPercent: number | undefined;
    securityDeviationPercent: number | undefined;
    securitySetDeviationPercent: number | undefined;
    subclassDeviationPercent: number | undefined;
    classDeviationPercent: number | undefined;
    categoryDeviationPercent: number | undefined;
}

export interface OrionEclipsePortfolioDetailIssuesModel {
    outOfTolerance: number;
    cashNeed: number;
    setForAutoRebalance: number;
    contributions: number;
    distribution: number;
    modelAssociation: number;
    doNotTrade: number | undefined;
    tlhOpportunity: number | undefined;
    dataErrors: number;
    pendingTrades: number;
}

export interface OrionEclipsePortfolioDetailTeamModel {
    id: number | undefined;
    name: string;
    isPrimary: number;
    portfolioAccess: number | undefined;
}

export interface OrionEclipsePortfolioDetailSummaryModel {
    analyticsOn: Date | undefined;
    reserveCashTarget: number;
    reserveCashActual: number;
    targetCash: number;
    currentCash: number;
    pendingCash: number;
    aum: OrionEclipsePortfolioDetailAumModel;
    realized: OrionEclipsePortfolioDetailRealizedModel;
}

export interface OrionEclipsePortfolioDetailAumModel {
    total: number;
    totalValue: number;
    managedValue: number;
    excludedValue: number;
    totalCash: OrionEclipsePortfolioDetailAumTotalCashModel;
}

export interface OrionEclipsePortfolioDetailAumTotalCashModel {
    total: number;
    reserve: number;
    cash: number;
    setAsideCash: number;
    reserveCashPercent: number;
    setAsideCashPercent: number;
}

export interface OrionEclipsePortfolioDetailRealizedModel {
    total: number;
    totalStatus: string;
    shortTerm: number;
    shortTermStatus: string;
    longTerm: number;
    longTermStatus: string;
}

/** An enumeration of all Permissions from the database, assigned to their PermissionID value. */
export enum Permission {
    ViewAccounts = "ViewAccounts",
    ViewRequestTracker = "ViewRequestTracker",
    SubmitContributionRequest = "SubmitContributionRequest",
    SubmitDistributionRequest = "SubmitDistributionRequest",
    SubmitReallocationRequest = "SubmitReallocationRequest",
    SubmitAccountCloseRequest = "SubmitAccountCloseRequest",
    SubmitPlanningDeskRequest = "SubmitPlanningDeskRequest",
    ViewFileMessages = "ViewFileMessages",
    SubmitMessageFile = "SubmitMessageFile",
    ViewResourceCenter = "ViewResourceCenter",
    ViewAlphastarForms = "ViewAlphastarForms",
    ViewTDAmeritradeForms = "ViewTDAmeritradeForms",
    ViewCharlesSchwabForms = "ViewCharlesSchwabForms",
    ViewComplianceCentralSso = "ViewComplianceCentralSso",
    ViewDevelopmentCenter = "ViewDevelopmentCenter",
    ViewNextLevel = "ViewNextLevel",
    ViewBetashieldSso = "ViewBetashieldSso",
    ViewOrionSso = "ViewOrionSso",
    ViewEnvestnetSso = "ViewEnvestnetSso",
    ViewPaytrace = "ViewPaytrace",
    SubmitNewFirelightAccount = "SubmitNewFirelightAccount",
    SubmitNewPaperAccount = "SubmitNewPaperAccount",
    ViewErisa401kPlanForms = "ViewErisa401kPlanForms",
    ViewInvestmentResourceForms = "ViewInvestmentResourceForms",
    ViewSchwabAdvisorCenterSso = "ViewSchwabAdvisorCenterSso",
    ViewEvolvExperience = "ViewEvolvExperience",
    ViewLumaSso = "ViewLumaSso",
    ViewSimonSso = "ViewSimonSso",
    ViewSimonManagerSso = "ViewSimonManagerSso",
    ViewOrionConnectSso = "ViewOrionConnectSso",
    ViewOrionElementSso = "ViewOrionElementSso",
    ViewOrionElementRequests = "ViewOrionElementRequests",
    ViewOrionElementProposals = "ViewOrionElementProposals",
    ViewOrionForms = "ViewOrionForms",
    AdminViewAllAdvisors = "AdminViewAllAdvisors",
    ViewFidelityWealthscapeSso = "ViewFidelityWealthscapeSso",
    ViewPonteraSso = "ViewPonteraSso",
    SubmitFinancialPlanRequest = "SubmitFinancialPlanRequest",
    ViewInvestorcomSso = "ViewInvestorcomSso",
    SubmitInitialAccountRequest = "SubmitInitialAccountRequest",
    SubmitReallocationV2Request = "SubmitReallocationV2Request",
    SubmitContributionV2Request = "SubmitContributionV2Request",
    SubmitDistributionV2Request = "SubmitDistributionV2Request",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

/* https://github.com/RicoSuter/NSwag/issues/3172 */